<template>
    <div
        :class="{ [`l-ss-c-filter-enum-${filter.name}`]: true, 'l-ss-c-filter-is-short': isShort }"
        class="l-ss-c-filter-enum">
        <c-label
            v-if="showTitle"
            :label="filterLabel"/>
        <span
            v-if="showSearchField"
            class="l-ss-c-filter-enum-search-wrap">
            <app-input
                v-model="localSearch"
                class="l-ss-c-filter-enum-search-input"
                :placeholder="$t('filters.enumSearch')"/>
        </span>
        <div
            class="l-ss-c-filter-enum-group-wrapper">
            <tree-enum-nodes
                v-model="activeCategories"
                @change="onChangeActiveCategory"
                :options="slicedCategoriesTree"
                :level="0"/>
        </div>
        <show-more-btn
            v-if="hasShowMore"
            class="l-ss-c-navigation-list-item-action"
            @click="emitChangeSize"
            v-model="showMore"/>
    </div>
</template>

<script>
    import useFilterCategoriesTree from '@/core/components/common/filters/filter-types/tree-enum/use-filter-categories-tree';

    import TreeEnumNodes from '@/core/components/common/filters/filter-types/tree-enum/tree-enum-nodes.vue';
    import CLabel from '@/core/components/common/filters/filter-types/components/label.vue';
    import ShowMoreBtn from '@/core/components/show-more-btn.vue';
    import AppInput from '@/core/components/common/app-input.vue';

    import FilterMixin from '../mixin';
    import { MIN_ITEMS_COUNT_FOR_SEARCH_FIELD, MIN_ITEMS_COUNT_FOR_SHOW_MORE } from '../mixin';

    export default {
        components: { AppInput, ShowMoreBtn, CLabel, TreeEnumNodes },
        mixins: [FilterMixin],
        provide() {
            return {
                onToggleOpen: this.emitChangeSize,
            };
        },
        props: {
            allCategoriesList: {
                type: Array,
            },
        },
        data() {
            return {
                categoriesTree: [],
                activeCategories: new Set(),
            };
        },
        computed: {
            showSearchField() {
                return this.localSearch || this.categoriesTree.length > MIN_ITEMS_COUNT_FOR_SEARCH_FIELD;
            },
            filterOptions() {
                return this.filter.options;
            },
            activeOptions() {
                return this.value.options || [];
            },
            hasShowMore() {
                if (this.forceShowAll) {
                    return false;
                }

                return (this.localSearch ? this.filteredCategoriesTree.length : this.categoriesTree.length) > MIN_ITEMS_COUNT_FOR_SHOW_MORE;
            },
            filteredCategoriesTree() {
                let filteredTree = this.categoriesTree;

                if (this.localSearch) {
                    filteredTree = useFilterCategoriesTree(this.allCategoriesList, this.filterOptions, this.localSearch);
                }

                return filteredTree;
            },
            slicedCategoriesTree() {
                return this.showMore ? this.filteredCategoriesTree : this.filteredCategoriesTree.slice(0, MIN_ITEMS_COUNT_FOR_SHOW_MORE);
            },
            activeCategoriesIds() {
                return Array.from(this.activeCategories);
            },
        },
        watch: {
            activeOptions(newOptions, oldOptions) {
                if (this.isNotEqualArrays(newOptions, oldOptions)) {
                    this.setCategoriesTree();
                }
            },
            filterOptions(newOptions, oldOptions) {
                if (this.isNotEqualArrays(newOptions, oldOptions)) {
                    this.setCategoriesTree();
                }
            },
        },
        created() {
            this.setCategoriesTree();
        },
        methods: {
            setCategoriesTree() {
                this.activeCategories = new Set();
                this.activeOptions.forEach((activeOptionId) => this.activeCategories.add(activeOptionId));

                this.categoriesTree = useFilterCategoriesTree(this.allCategoriesList, this.filterOptions);
            },
            emitChangeNodes(activeNodeIds) {
                if (activeNodeIds.length) {
                    this.onChange({
                        condition: 'in',
                        options: activeNodeIds,
                    });
                } else {
                    this.onChange();
                }
            },
            onChangeActiveCategory() {
                this.emitChangeNodes(this.activeCategoriesIds);
            },
            onToggleOpen() {
                this.$emit('change-size');
            },
            isNotEqualArrays(arr1, arr2) {
                let hasChanges = true;

                if (arr1.length === arr2.length) {
                    hasChanges = false;

                    for (let i = 0; i < arr1.length; ++i) {
                        if (arr1[i].id !== arr2[i].id) {
                            hasChanges = true;
                            break;
                        }
                    }
                }

                return hasChanges;
            },
        },
    };
</script>

<style scoped>

</style>
